import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { Star, MapPin, ArrowRight } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function TrendingStrip() {
  const { t } = useApp();
  const [pools, setPools] = useState([]);
  useEffect(() => { api.get("/pools/trending").then((r) => setPools(r.data)).catch(() => {}); }, []);
  if (!pools.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-6 py-12">
      <div className="flex items-end justify-between mb-6 flex-wrap gap-4">
        <div>
          <div className="overline text-[#E27B58] mb-2">{t("trending.badge")}</div>
          <h2 className="font-display text-3xl lg:text-4xl font-bold">{t("trending.title")}</h2>
        </div>
        <Link to="/search" className="text-sm font-semibold text-[#005C7A] hover:underline flex items-center gap-1" data-testid="trending-see-all">
          {t("trending.seeAll")} <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
      <div className="flex gap-4 overflow-x-auto pb-4 -mx-6 px-6 snap-x snap-mandatory">
        {pools.map((p) => (
          <Link key={p.pool_id} to={`/pool/${p.pool_id}`} className="pool-card block shrink-0 w-[280px] bg-white border border-border rounded-2xl overflow-hidden snap-start group" data-testid={`trending-${p.pool_id}`}>
            <div className="relative aspect-[4/3] overflow-hidden bg-muted">
              <img src={p.photos?.[0] ? fileUrl(p.photos[0]) : "https://images.unsplash.com/photo-1582533568805-78a15dcb01b5?w=600&q=80"} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute top-3 right-3 bg-[#E27B58] text-white text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">🔥 {t("trending.hot")}</div>
            </div>
            <div className="p-4">
              <h3 className="font-display font-semibold text-base truncate mb-1">{p.title}</h3>
              <div className="text-xs text-muted-foreground flex items-center gap-1 mb-2"><MapPin className="w-3 h-3" /> {p.city}</div>
              <div className="flex items-center justify-between">
                <div className="font-bold">€{p.price_per_day}<span className="text-xs text-muted-foreground font-normal"> / {t("pool.perDay").split("/")[0].trim()}</span></div>
                {p.review_count > 0 && (
                  <div className="flex items-center gap-1 text-xs"><Star className="w-3.5 h-3.5 fill-[#E27B58] text-[#E27B58]" /><span className="font-semibold">{p.rating_avg.toFixed(1)}</span></div>
                )}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
